interface ProductInfo {
    sku: string;
    variant_name: string;
    name: string;
    [key: string]: any;
}

const createFileName = (
    product: ProductInfo,
    extension: string,
    suffix?: string
): string => {
    const date = new Date();
    const versionByDate = date
    .toISOString()
    .replace(/[:.]/g, '-')
    .replace('T', '_')
    .substring(0, 19);

    let nameString = `(${product.sku})_${product.variant_name}_${product.name}_${versionByDate}${
        suffix ? `__${suffix}` : ''
    }.${extension}`;

    nameString = nameString.toLowerCase().replace(/-/g, '').replace(/ /g, '-');
    return nameString;
};

export default createFileName;